import {Pipe, PipeTransform} from '@angular/core';
/**
 * Created by Rumyantsev Daniil on 20.07.2018.
 */

@Pipe({name: 'deltaDesc'})
export class DeltaDesc implements PipeTransform {

  transform(val: string, valMeteringUnit: string): string {

    console.log("In delta desc val before cast is", val);
    const value = +val;
    console.log("In delta desc value is", value);
    console.log("In delta desc value < 0 is", value < 0);
    console.log("In delta desc value >= 0 is", value >= 0);
    console.log("In delta desc valueUnit is", valMeteringUnit);

    if(value == null) { return null; }

    if(value < 0 ) {
       return "Ожидаемый перерасчет " + value
          + (valMeteringUnit == null ? '' : ' ' + valMeteringUnit);
    }

    return "Ожидаемое потребление " + value
        + (valMeteringUnit == null ? '' : ' ' + valMeteringUnit);
  }

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/delta-desc.pipe.ts